import * as React from 'react';
import { WrappedFieldProps } from 'redux-form';
const styles = require('../../styles/components/_material-checkbox-input.scss');

export const CheckboxInput = (props: WrappedFieldProps & {id: string} & {hidden: boolean}) => {
    const {
        input: { onFocus, onBlur, ...input },
        meta: { error, submitFailed },
    } = props;

    return (
        <div >
            <input id={props.id} {...input} type={'checkbox'} hidden={props.hidden} />
            {error && submitFailed && <div className= 'MaterialCheckBoxInput--error' >{error}</div>}
        </div>
    );
};

export default CheckboxInput;
